'use client';

import { useTranslations } from 'next-intl';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { Typography } from '@/components/ui/typography';

interface Plan {
    name: string;
}

interface WhatIsPlanSectionProps {
    plan: Plan;
}

export function WhatIsPlanSection({ plan }: WhatIsPlanSectionProps) {
    const t = useTranslations('planDetails.emgoldexPlan.whatIsPlan');

    return (
        <SectionWrapper variant="default" padding="md" className="relative bg-gray-50 dark:bg-gray-900/50">
            <div className="container">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <Typography variant="h2" className="mb-6 text-gray-900 dark:text-white">
                            {t('title')}
                        </Typography>
                        <div className="space-y-6 text-gray-600 dark:text-gray-400 leading-relaxed">
                            <Typography variant="p">
                                {t('description1')}
                            </Typography>
                            <Typography variant="p">
                                {t('description2')}
                            </Typography>
                        </div>
                    </div>
                    <div className="relative">
                        {/* Matrix Structure Info */}
                        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 border-2 border-primary-200 dark:border-primary-800">
                            <Typography variant="h3" className="text-lg font-bold text-gray-900 dark:text-white mb-4">
                                {t('matrixStructure.title')}
                            </Typography>
                            <ul className="space-y-2">
                                <li className="flex items-start gap-2">
                                    <span className="text-primary-600 dark:text-primary-400 font-semibold">1.</span>
                                    <Typography variant="p" className="text-gray-700 dark:text-gray-300">
                                        {t('matrixStructure.level1')}
                                    </Typography>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-primary-600 dark:text-primary-400 font-semibold">2.</span>
                                    <Typography variant="p" className="text-gray-700 dark:text-gray-300">
                                        {t('matrixStructure.level2')}
                                    </Typography>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-primary-600 dark:text-primary-400 font-semibold">3.</span>
                                    <Typography variant="p" className="text-gray-700 dark:text-gray-300">
                                        {t('matrixStructure.level3')}
                                    </Typography>
                                </li>
                                <li className="flex items-start gap-2">
                                    <span className="text-primary-600 dark:text-primary-400 font-semibold">4.</span>
                                    <Typography variant="p" className="text-gray-700 dark:text-gray-300">
                                        {t('matrixStructure.level4')}
                                    </Typography>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
}

